// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2C2.9 2 2 2.9 2 4M12 2C13.1 2 14 2.9 14 4M14 12C14 13.1 13.1 14 12 14M4 14C2.9 14 2 13.1 2 12',
  'M6.75 2H9.25M6.75 14H9.25M2 6.75V9.25M14 6.75V9.25',
  'M5.61 6.67C7.97 5.49 8 8.05 10.39 6.67M5.61 9.3C7.97 8.11 8 10.67 10.39 9.3',
];
